import { Box, CardActions, Grid, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import DirectionsRunIcon from "@material-ui/icons/DirectionsRun";
import PhoneAndroidIcon from "@material-ui/icons/PhoneAndroid";
import CardTitle from "@saleor/components/CardTitle";
import { maybe } from "@saleor/misc";
import {
  DeliveryTypeEnum,
  SmopOrderStatusEnum,
  SmopUserTypeCode
} from "@saleor/types/globalTypes";
import { hasPermission } from "@saleor/utils/handlers/OrderFulfillmentHandlers";
import React from "react";

import {
  StoreOrderDetails_storeOrder_order_dropOffLocation,
  StoreOrderDetails_storeOrder_runner
} from "../../types/StoreOrderDetails";

export interface StoreOrderAssignedRunnerProps {
  assignRunnerDialog: () => void;
  runnerData: StoreOrderDetails_storeOrder_runner;
  status: SmopOrderStatusEnum;
  deliveryType: DeliveryTypeEnum;
  loading: boolean;
  userType: SmopUserTypeCode;
  homeLocation: StoreOrderDetails_storeOrder_order_dropOffLocation;
  disableAction: boolean;
  binCode: string;
}

const useStyles = makeStyles(
  theme => ({
    cardContent: {
      paddingBottom: "4px"
    },
    root: {
      ...theme.typography.body1,
      lineHeight: 1.9,
      width: "100%"
    },
    runnerDetailsContent: {
      alignItems: "center",
      display: "flex",
      fontSize: "17px",
      marginBottom: "6px"
    },
    textBold: {
      fontSize: "14px",
      fontWeight: 600,
      textAlign: "left"
    },
    textRight: {
      fontSize: "14px",
      textAlign: "left"
    }
  }),
  { name: "StoreOrderAssignedRunner" }
);

const StoreOrderAssignedRunner: React.FC<StoreOrderAssignedRunnerProps> = props => {
  const {
    assignRunnerDialog,
    runnerData,
    status,
    deliveryType,
    loading,
    userType,
    homeLocation,
    disableAction,
    binCode
  } = props;
  const classes = useStyles(props);
  const { NEW_ORDER, ACKNOWLEDGED, READY } = SmopOrderStatusEnum;
  const {
    EXPRESS,
    EXPRESS_LONG_DISTANCE,
    NEXT_DAY,
    SAME_DAY,
    NATIONWIDE_DELIVERY
  } = DeliveryTypeEnum;
  const { OMI_OPS } = SmopUserTypeCode;

  const showChangeButton =
    hasPermission(
      { deliveryType, status, userType },
      [EXPRESS, EXPRESS_LONG_DISTANCE, SAME_DAY],
      [NEW_ORDER, ACKNOWLEDGED, READY],
      [OMI_OPS],
      loading
    ) ||
    hasPermission(
      { deliveryType, status, userType },
      [NEXT_DAY, NATIONWIDE_DELIVERY],
      [READY],
      [OMI_OPS],
      loading
    );

  return (
    <Card>
      <CardTitle title="Assigned Runner" />
      <CardContent
        id="AssignedRunnerCardContent"
        className={classes.cardContent}
      >
        {runnerData ? (
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={12}>
              <span className={classes.runnerDetailsContent}>
                <DirectionsRunIcon
                  style={{
                    color: "#9B51E0",
                    fontSize: "33px",
                    marginRight: "10px"
                  }}
                />
                {runnerData?.firstName
                  ? `${runnerData?.firstName} ${runnerData?.lastName}`
                  : ""}
              </span>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <span className={classes.runnerDetailsContent}>
                <PhoneAndroidIcon
                  style={{
                    color: "#9B51E0",
                    fontSize: "27px",
                    marginLeft: "4px",
                    marginRight: "13px"
                  }}
                />
                {runnerData?.contactNo ? runnerData?.contactNo : "--"}
              </span>
            </Grid>
          </Grid>
        ) : (
          <Typography variant="subtitle1" align="center">
            No runner has been assigned{" "}
          </Typography>
        )}
        <Box
          display="flex"
          justifyContent="space-between"
          style={{ marginTop: "1em" }}
        >
          <Typography
            variant="subtitle1"
            style={{ fontWeight: 600 }}
            align="center"
          >
            Home Location
          </Typography>
          <Typography
            id="homeLocationTitleHeader"
            variant="subtitle1"
            align="center"
          >
            {maybe(() => homeLocation?.name, "N/A")}
          </Typography>
        </Box>
        {deliveryType === DeliveryTypeEnum.EXPRESS ||
        deliveryType === DeliveryTypeEnum.EXPRESS_LONG_DISTANCE ||
        deliveryType === DeliveryTypeEnum.SAME_DAY ? (
          <Box
            display="flex"
            justifyContent="space-between"
            style={{ marginTop: "1em" }}
            alignItems="center"
          >
            <Typography
              variant="subtitle1"
              style={{ fontWeight: 600 }}
              align="center"
            >
              Dispatch Area
            </Typography>
            <Typography
              id="homeLocationTitleHeader"
              variant="subtitle1"
              style={{ fontSize: 25, fontWeight: 600 }}
              align="center"
            >
              {binCode ? binCode : "--"}
            </Typography>
          </Box>
        ) : (
          ""
        )}
      </CardContent>
      {showChangeButton ? (
        <CardActions>
          <Button
            id="assignRunnerDialogBtn"
            variant="contained"
            color="primary"
            fullWidth
            onClick={assignRunnerDialog}
            disabled={disableAction}
          >
            Change
          </Button>
        </CardActions>
      ) : null}
    </Card>
  );
};

StoreOrderAssignedRunner.displayName = "AssignedRunner";
export default StoreOrderAssignedRunner;
